export default __webpack_public_path__ + "1fe99538ea709f658096f1b316e97477.png";